const dBEntitiesConst: any = {
  BusnPartner: {
    tableName: "BusnPartner",
    primaryKeyColumnName: "BusnPartnerId",
  },

  Products: {
    tableName: "Products",
    primaryKeyColumnName: "productid",
  },
  Machines: {
    tableName: "machines",
    primaryKeyColumnName: "machine_id",
  },

};

export default dBEntitiesConst;

